<script>
// import NavBar from '@components/nav-bar.vue'

import store from '@state/store'
import TopMenu from '@router/components/top-menu.vue'
import LeftMenu from '@router/components/left-menu.vue'
import UserEdit from '@router/components/user-edit.vue'
import NotificationsDrawer from '@router/components/notifications-drawer.vue'
import NotificationSettings from '@router/components/notification-settings.vue'
import { authComputed } from '@state/helpers'
import ClickOutside from 'vue-click-outside'
import initialEcho from '@router/echo'
import { format, parseISO } from 'date-fns/fp'

export default {
  // components: { NavBar },
  components: {
    TopMenu,
    LeftMenu,
    UserEdit,
    NotificationsDrawer,
    NotificationSettings,
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      showOverlay: false,
      searchTerm: '',
      searchResults: false,
      activeSearchFilter: 'all',
      userEditVisible: false,
      notificationsDrawerVisible: false,
      notificationSettingsVisible: false,
    }
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.$nextTick(() => {
      initialEcho()

      if (this.$route.meta.tmp && this.$route.meta.tmp.showUserProfile) {
        this.userEditVisible = true
      }
    })
  },
  methods: {
    toggleOverlay(params) {
      this.showOverlay = params.showHide
    },
    setSearchFilter(type) {
      this.activeSearchFilter = type
    },
    search(params) {
      store
        .dispatch('auth/search', {
          term: params.searchTerm,
        })
        .then((response) => {
          this.searchResults = response
        })
    },
    showUserEdit() {
      this.userEditVisible = true
    },
    closeUserEdit() {
      this.userEditVisible = false
      if (this.$route.meta.tmp.showUserProfile) {
        const { name, params } = this.$route
        this.$router.push({
          name: name,
          params: { companyId: params.companyId },
        })
      }
    },
    hide() {
      this.searchResults = false
      this.notificationsDrawerVisible = false
    },
    toggleNotificationsDrawer(e) {
      e.stopPropagation()
      this.notificationsDrawerVisible = !this.notificationsDrawerVisible
    },
    showNotificationSettings() {
      this.notificationSettingsVisible = true
    },
    hideNotificationSettings() {
      this.notificationSettingsVisible = false
    },
    startDateFormatted(start) {
      return format('EEE, MMM d, Y', parseISO(start))
    },
    hoursFormatted(opportunity) {
      return (
        format('hh:mm a', parseISO(opportunity.start)) +
        ' - ' +
        format('hh:mm a', parseISO(opportunity.end))
      )
    },
  },
}
</script>

<template>
  <div v-if="currentUser" class="bg-blue-lightest">
    <div>
      <div
        :class="{ hidden: !showOverlay }"
        class="fixed inset-0 z-20 opacity-75 bg-blue-lighter"
      ></div>
      <TopMenu
        :notifications="currentNotifications"
        @search="search"
        @show-user-edit="showUserEdit"
        @show-notifications-drawer="toggleNotificationsDrawer"
      ></TopMenu>

      <BaseModalWindow
        v-if="userEditVisible"
        modalcls="user-edit w-full max-w-1.95xl bg-white rounded-xl ml-15 px-10 py-8 shadow-box relative left-0"
        :visible="userEditVisible"
        @close="closeUserEdit"
      >
        <template v-slot:body>
          <UserEdit :user="currentUser" @close="closeUserEdit" />
        </template>
      </BaseModalWindow>

      <NotificationsDrawer
        v-if="notificationsDrawerVisible"
        v-click-outside="hide"
        :current-notifications="currentNotifications"
        @show-notification-settings="showNotificationSettings"
      ></NotificationsDrawer>

      <NotificationSettings
        :notification-settings="notificationSettings"
        :notification-settings-visible="notificationSettingsVisible"
        class="absolute"
        @hide-notification-settings="hideNotificationSettings"
      ></NotificationSettings>

      <div
        v-if="searchResults"
        v-click-outside="hide"
        class="fixed inset-x-0 z-20 w-full bg-gray-lighter inset-t-28 shadow-search"
      >
        <div class="w-content ml-26 pl-15 pr-40 mt-7.5 mb-4.5">
          <div class="mb-5 text-xl text-blue-darker">Search By:</div>
          <div class="flex">
            <button
              class="button border rounded-input text-basel mr-7 px-7.5"
              :class="[
                activeSearchFilter === 'all'
                  ? 'bg-blue-default text-white border-blue-default'
                  : 'bg-white text-blue border-gray-light',
              ]"
              @click="setSearchFilter('all')"
              >All</button
            >
            <button
              class="button border rounded-input text-basel mr-7 px-7.5"
              :class="[
                activeSearchFilter === 'people'
                  ? 'bg-blue-default text-white border-blue-default'
                  : 'bg-white text-blue border-gray-light',
              ]"
              @click="setSearchFilter('people')"
              >People</button
            >
            <button
              class="button border rounded-input text-basel mr-7 px-7.5"
              :class="[
                activeSearchFilter === 'hubs'
                  ? 'bg-blue-default text-white border-blue-default'
                  : 'bg-white text-blue border-gray-light',
              ]"
              @click="setSearchFilter('hubs')"
              >Business or school</button
            >
            <button
              class="button border rounded-input text-basel mr-7 px-7.5"
              :class="[
                activeSearchFilter === 'groups'
                  ? 'bg-blue-default text-white border-blue-default'
                  : 'bg-white text-blue border-gray-light',
              ]"
              @click="setSearchFilter('groups')"
              >Groups</button
            >
            <button
              class="button border rounded-input text-basel mr-7 px-7.5"
              :class="[
                activeSearchFilter === 'opportunities'
                  ? 'bg-blue-default text-white border-blue-default'
                  : 'bg-white text-blue border-gray-light',
              ]"
              @click="setSearchFilter('opportunities')"
              >Volunteer Opportunities</button
            >
            <button
              class="button border rounded-input text-basel mr-7 px-7.5"
              :class="[
                activeSearchFilter === 'tags'
                  ? 'bg-blue-default text-white border-blue-default'
                  : 'bg-white text-blue border-gray-light',
              ]"
              @click="setSearchFilter('tags')"
              >Tags</button
            >
            <button
              class="button border rounded-input text-basel mr-7 px-7.5"
              :class="[
                activeSearchFilter === 'causes'
                  ? 'bg-blue-default text-white border-blue-default'
                  : 'bg-white text-blue border-gray-light',
              ]"
              @click="setSearchFilter('causes')"
              >Causes</button
            >
            <button
              class="button border rounded-input text-basel mr-7 px-7.5"
              :class="[
                activeSearchFilter === 'organization'
                  ? 'bg-blue-default text-white border-blue-default'
                  : 'bg-white text-blue border-gray-light',
              ]"
              @click="setSearchFilter('organizations')"
              >Organization</button
            >
          </div>
          <div class="mt-6 mb-4 border-t border-gray-dark-transparent"></div>
          <div
            class="h-56 px-6 py-2 overflow-y-scroll bg-white border rounded-comments border-gray-light"
          >
            <div
              v-if="
                activeSearchFilter === 'all' || activeSearchFilter === 'people'
              "
              class="mb-6"
            >
              <div class="text-lg text-blue-darker">People: </div>
              <div
                class="mt-2 mb-2 border-t border-gray-dark-transparent"
              ></div>
              <div
                v-if="searchResults.users && !searchResults.users.length"
                class="text-black"
                >No Results</div
              >
              <div
                v-for="oneUser in searchResults.users"
                :key="oneUser.id"
                class="flex justify-between mb-3 w-300"
              >
                <router-link
                  :to="{ name: 'user-page', params: { userId: oneUser.id } }"
                >
                  <img
                    :src="oneUser.image_url"
                    class="inline-block w-6 h-6 mr-4 rounded-full "
                  />
                  <span class="text-lg text-blue">{{ oneUser.name }}</span>
                </router-link>
              </div>
            </div>
            <div
              v-if="
                activeSearchFilter === 'all' || activeSearchFilter === 'hubs'
              "
              class="mb-6"
            >
              <div class="text-lg text-blue-darker">Business or school: </div>
              <div
                class="mt-2 mb-2 border-t border-gray-dark-transparent"
              ></div>
              <div
                v-if="searchResults.hubs && !searchResults.hubs.length"
                class="text-black"
                >No Results</div
              >
              <div
                v-for="oneHub in searchResults.hubs"
                :key="oneHub.id"
                class="flex justify-between mb-3 w-300"
              >
                <router-link
                  :to="{ name: 'company', params: { companyId: oneHub.id } }"
                >
                  <img
                    :src="oneHub.image_url"
                    class="inline-block w-6 h-6 mr-4 rounded-full "
                  />
                  <span class="text-lg text-blue">{{ oneHub.name }}</span>
                </router-link>
              </div>
            </div>
            <div
              v-if="
                activeSearchFilter === 'all' || activeSearchFilter === 'groups'
              "
              class="mb-6"
            >
              <div class="text-lg text-blue-darker">Groups: </div>
              <div
                class="mt-2 mb-2 border-t border-gray-dark-transparent"
              ></div>
              <div
                v-if="searchResults.groups && !searchResults.groups.length"
                class="text-black"
                >No Results</div
              >
              <div
                v-for="oneGroup in searchResults.groups"
                :key="oneGroup.id"
                class="flex justify-between mb-3 w-300"
              >
                <router-link
                  :to="{
                    name: 'group',
                    params: {
                      companyId: oneGroup.company_id,
                      groupId: oneGroup.id,
                    },
                  }"
                >
                  <img
                    :src="oneGroup.image_url"
                    class="inline-block w-6 h-6 mr-4 rounded-full "
                  />
                  <span class="text-lg text-blue">{{ oneGroup.name }}</span>
                </router-link>
              </div>
            </div>
            <div
              v-if="
                activeSearchFilter === 'all' ||
                  activeSearchFilter === 'opportunities'
              "
              class="mb-6"
            >
              <div class="text-lg text-blue-darker"
                >Volunteer Opportunities:
              </div>
              <div
                class="mt-2 mb-2 border-t border-gray-dark-transparent"
              ></div>
              <div
                v-if="
                  searchResults.opportunities &&
                    !searchResults.opportunities.length
                "
                class="text-black"
                >No Results</div
              >
              <div
                v-for="oneOpportunity in searchResults.opportunities"
                :key="oneOpportunity.id"
                class="flex justify-between mb-3 w-full"
              >
                <router-link
                  :to="{
                    name: 'eventDetails',
                    params: {
                      companyId: oneOpportunity.group.company_id,
                      eventId: oneOpportunity.id,
                    },
                  }"
                >
                  <span class="text-lg text-blue">{{
                    oneOpportunity.name
                  }}</span>
                  on
                  <div class="event-meta inline-block m-0">
                    <span class="event-date">{{
                      startDateFormatted(oneOpportunity.start)
                    }}</span>
                    <span class="event-time">{{
                      hoursFormatted(oneOpportunity)
                    }}</span>
                  </div>
                </router-link>
              </div>
            </div>
            <div
              v-if="
                activeSearchFilter === 'all' || activeSearchFilter === 'tags'
              "
              class="mb-6"
            >
              <div class="text-lg text-blue-darker">Tags: </div>
              <div
                class="mt-2 mb-2 border-t border-gray-dark-transparent"
              ></div>
              <div
                v-if="searchResults.tags && !searchResults.tags.length"
                class="text-black"
                >No Results</div
              >
              <div
                v-for="oneTag in searchResults.tags"
                :key="oneTag.id"
                class="flex justify-between mb-3 w-300"
              >
                <router-link
                  :to="{ name: 'tag', params: { tagId: oneTag.id } }"
                >
                  <span class="text-lg text-blue">{{ oneTag.name }}</span>
                </router-link>
              </div>
            </div>
            <div
              v-if="
                activeSearchFilter === 'all' || activeSearchFilter === 'causes'
              "
              class="mb-6"
            >
              <div class="text-lg text-blue-darker">Causes: </div>
              <div
                class="mt-2 mb-2 border-t border-gray-dark-transparent"
              ></div>
              <div
                v-if="searchResults.causes && !searchResults.causes.length"
                class="text-black"
                >No Results</div
              >
              <div
                v-for="oneCause in searchResults.causes"
                :key="oneCause.id"
                class="flex justify-between mb-3 w-300"
              >
                <router-link
                  :to="{ name: 'cause', params: { causeId: oneCause.id } }"
                >
                  <span class="text-lg text-blue">{{ oneCause.name }}</span>
                </router-link>
              </div>
            </div>
            <div
              v-if="
                activeSearchFilter === 'all' ||
                  activeSearchFilter === 'organizations'
              "
              class="mb-6"
            >
              <div class="text-lg text-blue-darker">Organizations: </div>
              <div
                class="mt-2 mb-2 border-t border-gray-dark-transparent"
              ></div>
              <div
                v-if="
                  searchResults.organizations &&
                    !searchResults.organizations.length
                "
                class="text-black"
                >No Results</div
              >
              <div
                v-for="oneOrganization in searchResults.organizations"
                :key="oneOrganization.id"
                class="flex justify-between mb-3 w-300"
              >
                <router-link
                  :to="{
                    name: 'organization',
                    params: { organizationId: oneOrganization.id },
                  }"
                >
                  <span class="text-lg text-blue">{{
                    oneOrganization.name
                  }}</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <LeftMenu :user="currentUser"></LeftMenu>
        <div
          id="rightContent"
          class="relative min-h-screen w-content ml-26 mt-28"
        >
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
